<template>
    <div :class="[
            'pp-cover-box',
            `is-${fixed}`,
            `is-${direction}`,
        ]">
        <slot></slot>
    </div>
</template>

<script>
/**
 * 固定容器
 * @param {String} fixed 位置
 * @param {Boolean} dragable 拖动
 * @param {String} direction 对齐方式
 */
export default {
    name: 'pp-cover-box',
    props: {
        fixed: {
            type: String,
            default: 'bottom-right',
            validator: function(value) {
                return [
                        'top-left', 
                        'top-right', 
                        'top', 
                        'bottom-left', 
                        'bottom-right', 
                        'bottom'
                    ].includes(value);
            },
        },
        direction: {
            type: String,
            default: 'column',
            validator: function(value) {
                return ['row', 'column'].includes(value);
            },
        },
        dragable: Boolean, // next verson
    },
}
</script>
